import React, { useState } from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";
import InitialScheduleTermForm from "./InitialScheduleTermForm";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Targets,
  Actions,
} from "features/../../../shared/constants/permissions";

const AddInitialScheduleTermModal = ({
  as: As = Button,
  onSubmitted,
  dealerId,
  createAction,
  title,
  triggerText,
  ...props
}) => {
  const [uploadDoc, setUploadDoc] = useState(null);

  const onChangeUpload = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setUploadDoc(res);
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <PermissionCheck target={Targets.Dealer} action={Actions.Edit}>
      <ModalBuilder
        withForm
        submitAction={createAction}
        submitParams={{ dealerId, uploadDoc }}
        onSubmitted={onSubmitted}
        renderTrigger={(showModal) => (
          <As {...props} primary onClick={showModal}>
            {triggerText}
          </As>
        )}
        renderModal={(modalProps, formProps) => (
          <Modal.Add {...modalProps} header={title}>
            <InitialScheduleTermForm
              {...formProps}
              onChangeUpload={onChangeUpload}
              editMode={false}
            />
          </Modal.Add>
        )}
      />
    </PermissionCheck>
  );
};

export default AddInitialScheduleTermModal;
